import GTM from '@grebban/gtm';

export default ({ application, page }) => {
    GTM.addDataLayerEvent('page_view', {
        currency: application.shop_config.currency,
        'site_id': application.applicationId,
        'page_title': page.data.title ? page.data.title : page.data.name ? page.data.name : '404',
    });
};
